import React from "react";
import DateUtils from "Utils/DateUtils";
import LinearLoader from "./LinearLoader";
import MemberBreakdownList from "./MemberBreakdownList";
import { ReactComponent as EmailSubjectIcon } from "Assets/svg/outbox/emailSubject.svg";
import { ReactComponent as LinkedinIcon } from "Assets/svg/linkedInOutlined.svg";

const isLinkedInTaskType = (taskType = "") =>
  taskType?.toLowerCase().startsWith("linkedin") || taskType?.toLowerCase().startsWith("li");

const getPlainText = (html = "") => {
  const elem = document.createElement("div");
  elem.innerHTML = html;
  elem.querySelectorAll("blockquote, .gmail_quote, .gmail_attr, .ql-editor, .ql-clipboard").forEach(el => el.remove());
  return elem.innerText?.trim() || "";
};

const LatestRepliesWidget = ({ replies = [], isLoading = false, memberBreakdown, breakdownLoading }) => {
  if (isLoading) {
    return <LinearLoader visible={true} />;
  }

  const breakdown =
    breakdownLoading || (memberBreakdown && memberBreakdown.length > 0) ? (
      <div className="latestRepliesWidgetBreakdown">
        <p className="latestRepliesWidgetBreakdownTitle">Replies by member</p>
        <MemberBreakdownList rows={memberBreakdown} loading={breakdownLoading} />
      </div>
    ) : null;

  if (!replies.length) {
    return (
      <div className="latestRepliesWidgetWrap">
        <div className="latestRepliesWidgetEmpty">
          <div className="latestRepliesWidgetEmptyIcon">
            <i className="material-icons-outlined">forum</i>
          </div>
          <span className="latestRepliesWidgetEmptyText">No replies yet</span>
        </div>
        {breakdown}
      </div>
    );
  }

  return (
    <div className="latestRepliesWidgetWrap">
      <div className="latestRepliesWidgetList">
        {replies.map((item, idx) => {
          const { task = {}, contact = [] } = item || {};
          const { taskType = "", touchPoint = {}, replyDate = "", replyContent = "" } = task || {};
          const { email = "", firstName = "", lastName = "" } = contact?.[0] || {};
          const isLinkedIn = isLinkedInTaskType(taskType);
          const contactName = [firstName, lastName].filter(Boolean).join(" ");
          const message = isLinkedIn
            ? getPlainText(replyContent) || "—"
            : touchPoint?.repliedSubject || touchPoint?.subject || "—";

          return (
            <div className="latestRepliesWidgetRow" key={task?.id || idx}>
              <div className={`latestRepliesWidgetIcon ${isLinkedIn ? "isLinkedIn" : "isEmail"}`}>
                {isLinkedIn ? <LinkedinIcon /> : <EmailSubjectIcon />}
              </div>
              <div className="latestRepliesWidgetInfo">
                <span className="latestRepliesWidgetEmail">{isLinkedIn ? contactName || "—" : email || "—"}</span>
                <span className="latestRepliesWidgetMessage">{message}</span>
              </div>
              <span className="latestRepliesWidgetDate">
                {replyDate ? DateUtils.formatDateByMonthText(replyDate) : ""}
              </span>
            </div>
          );
        })}
      </div>
      {breakdown}
    </div>
  );
};

export default LatestRepliesWidget;
